import { memo, useEffect, useState } from 'react';
import HomeBanner from './HomeBanner';
import HomeBuild from './HomeBuild';
import HomeCounter from './HomeCounter';
import HomeServices from './HomeServices';
import HomeChoose from './HomeChoose';
import HomeExpert from './HomeExpert';
import HomeExecute from './HomeExecute';
import HomeFacility from './HomeFacility';
import HomeStories from './HomeStories';
import HomeProject from './HomeProject';
import HomeQuote from './HomeQuote';
import HomeProcess from './HomeProcess';
import HomeMessage from './HomeMessage';
import HomeMedia from './HomeMedia';
import GetInTouch from '../GetInTouch/GetInTouch';

const Home = () => {

  const [isScroll, setIsScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScroll(true);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <main className="home-container">
      <HomeBanner />
      <HomeBuild />
      {isScroll && (
        <>
          <HomeCounter />
          <HomeServices />
          <HomeChoose />
          <section id="expert"><HomeExpert /></section>
          <section id="execute"><HomeExecute /></section>
          <section id="facility"><HomeFacility /></section>
          <section id="stories" className="homepage-testi"><HomeStories /></section>
          <HomeProject />
          <HomeQuote />
          <HomeProcess />
          <HomeMessage />
          <HomeMedia />
          <GetInTouch />
        </>
      )}

    </main>
  );
};

export default memo(Home);



